import React from 'react';
import { Row, Col } from 'react-bootstrap';
import DefaultBannerImg from '../assets/images/sell-banner.png';
import ArrowIcon from '../assets/images/button-arrow.svg';
import { Link } from 'react-router-dom';

const BecomeAgentBanner = ({ data, bannerImage }) => {
  const title = data?.title || 'Create your <span>real estate</span><br> agent profile';
  const subtitle = data?.subtitle || '';
  const btnName = data?.btn_name || 'Signup Now';
  const btnLink = data?.btn_link || '#';
  const image = bannerImage || DefaultBannerImg;

  return (
    <section className="about-banner-section">
      <Row>
        <Col lg={6} md={12} className="about-content-box align-self-center">
          <div className="about-content">
            <h1 className="about-title" dangerouslySetInnerHTML={{ __html: title }} />
            <p className="about-description">{subtitle}</p>
            <Link to={btnLink} target="_blank" className="custom-bttn style-3 ani-1 right">
              {btnName} <img src={ArrowIcon} alt="Arrow Icon" />
            </Link>
          </div>
        </Col>
        <Col lg={6} md={12}>
          <div className="about-image">
            <img src={image} alt="Become an Agent" className="house-img" />
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default BecomeAgentBanner;